<template>
  <v-menu
    v-model="menu"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <button
        v-bind="attrs"
        v-on="on"
        class="pr-2"
        icon
      >
        <v-icon>add_photo_alternate</v-icon>
        <v-icon class="ml-n2">
          arrow_drop_down
        </v-icon>
      </button>
    </template>
    <v-list>
      <UploadImageButton
        @insertImage="insertImage"
        :reflection-id="reflectionId"
      >
        <v-list-item class="imageMenu-ListItem">
          <v-icon small class="pl-1">
            file_upload
          </v-icon>
          <button class="imageMenu-ItemBtn">
            {{ $t('components.editor.imageMenuActions.upload') }}
          </button>
        </v-list-item>
      </UploadImageButton>

      <ImageInsertionDialog
        @insertImage="insertImage"
        @cancel="menu = false"
      >
        <v-list-item class="imageMenu-ListItem">
          <v-icon small class="pl-1">
            link
          </v-icon>
          <button class="imageMenu-ItemBtn">
            {{ $t('components.editor.imageMenuActions.urlLink') }}
          </button>
        </v-list-item>
      </ImageInsertionDialog>
    </v-list>
  </v-menu>
</template>

<script>
import ImageInsertionDialog from './ImageInsertionDialog';
import UploadImageButton from './UploadImageButton';

export default {
  name: 'EditorImageMenu',
  components: {
    ImageInsertionDialog,
    UploadImageButton,
  },
  props: {
    reflectionId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      menu: false,
    };
  },
  methods: {
    insertImage(metadata) {
      this.menu = false;
      this.$emit('insertImage', metadata);
    },
  },
};
</script>

<style>
.imageMenu-ListItem {
  padding: 0;
  min-height: 30px;
}

.imageMenu-ListItem:hover {
  background-color: lightgrey;
}

.imageMenu-ItemBtn {
  padding: 0px 8px;
  font-size: 12px;
}

</style>
